module.exports = __webpack_public_path__ + "img/browse-image.b885b119.svg";